export const KPIMutationKeys = {
  all: () => ["KPIs"],
  reviewCreate: () => [...KPIMutationKeys.all(), "reviewCreate"],
  recalculations: (engagementId: string | number) => [
    ...KPIMutationKeys.all(),
    "recalculations",
    String(engagementId)
  ]
};
